// Module
var code = "<div class=\"btn btn-primary btn-xs\" popout ng-attr-id=\"{{$ctrl.txnGuid}}\" ng-if=\"$ctrl.href\" href=\"{{$ctrl.href}}\">View </div>";
// Exports
module.exports = code;